import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import AuthShell from "./AuthShell";

export default function Signup() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", company: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await register(form);
    setLoading(false);
    if (res.ok) {
      toast.success("Account created — DOX is ready.");
      navigate("/dashboard");
    } else {
      setError(res.error);
    }
  };

  const upd = (k) => (v) => setForm({ ...form, [k]: v });

  return (
    <AuthShell
      title="Start your free trial"
      subtitle="14 days free. No credit card required."
      footer={<>Already have an account? <Link to="/login" data-testid="link-login" className="text-dox-orange font-semibold hover:underline">Log in</Link></>}
    >
      <form onSubmit={submit} className="space-y-4" data-testid="signup-form">
        <div className="grid grid-cols-2 gap-4">
          <Input label="Name" testid="signup-name" value={form.name} onChange={upd("name")} />
          <Input label="Company" testid="signup-company" value={form.company} onChange={upd("company")} required={false} />
        </div>
        <Input label="Email" type="email" testid="signup-email" value={form.email} onChange={upd("email")} />
        <Input label="Password" type="password" testid="signup-password" value={form.password} onChange={upd("password")} hint="Minimum 6 characters" />
        {error && <p className="text-sm text-red-400" data-testid="signup-error">{error}</p>}
        <button
          data-testid="signup-submit"
          disabled={loading}
          className="w-full rounded-full bg-dox-orange py-3.5 font-bold text-white hover:bg-dox-orangeHover disabled:opacity-60 transition-all"
        >
          {loading ? "Creating account…" : "Create account"}
        </button>
      </form>
    </AuthShell>
  );
}

function Input({ label, type = "text", value, onChange, testid, required = true, hint }) {
  return (
    <label className="block">
      <span className="text-xs font-semibold text-white/50 uppercase tracking-wider mb-1.5 block">{label}</span>
      <input
        data-testid={testid}
        required={required}
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white outline-none focus:border-dox-orange focus:ring-2 focus:ring-dox-orange/20 transition"
      />
      {hint && <span className="text-[11px] text-white/35 mt-1 block">{hint}</span>}
    </label>
  );
}
